export interface QuickGuideSlide {
  id: string;
  title: string;
  icon: string;
  image?: string;
  points: string[];
  highlight?: string;
}

export const quickGuideData: QuickGuideSlide[] = [
  {
    id: 'goal',
    title: 'ゲームの目標',
    icon: '🎯',
    points: [
      '相手のライフポイント（LP）を0にすれば勝利！',
      '初期LP: 6000',
      'モンスターで攻撃してLPを削ろう',
    ],
    highlight: '相手のLPを0にしろ！',
  },
  {
    id: 'sp',
    title: 'SPトークン',
    icon: '💎',
    points: [
      'カードを使うための資源',
      '毎ターン開始時に+1（最大10）',
      '使うとレスト状態（◇）になる',
      'ターン開始で全てアクティブ（◆）に回復',
    ],
    highlight: 'SPがないとカードは使えない！',
  },
  {
    id: 'turn',
    title: 'ターンの流れ',
    icon: '🔄',
    points: [
      '① ターン開始: SP回復 & +1',
      '② ドロー: 1枚引く',
      '③ メイン: カードを出す・技を使う',
      '④ バトル: モンスターで攻撃',
      '⑤ エンド: ターン終了',
    ],
  },
  {
    id: 'cards',
    title: 'カードの種類',
    icon: '🃏',
    points: [
      '👹 モンスター: 攻撃・防御の主力',
      '✨ 魔法: 即時効果で状況を変える',
      '🏔️ フィールド: 場全体に永続効果',
      '⏳ フェイズ: カードを重ねて成長',
    ],
  },
  {
    id: 'summon',
    title: 'モンスター召喚',
    icon: '⚔️',
    image: '/images/help/game-overview.png',
    points: [
      '手札のモンスターを選択',
      'コスト分のSPを支払う',
      'フィールドに配置（最大5体）',
      '召喚したターンも攻撃OK！',
    ],
  },
  {
    id: 'battle',
    title: 'バトル',
    icon: '💥',
    points: [
      '攻撃力分のダメージを相手HPに与える',
      'HPが0になったモンスターは破壊',
      '攻撃すると反撃で30%ダメージを受ける',
      '相手にモンスターがいなければ直接攻撃！',
    ],
    highlight: '先攻1ターン目は攻撃不可',
  },
  {
    id: 'skill',
    title: '技の発動',
    icon: '✨',
    points: [
      'カードかSPをモンスターにチャージ',
      '基本技: 1チャージで発動',
      '上級技: 2チャージで発動',
      '1ターンに1回のみチャージ可能',
    ],
    highlight: '技で戦況を有利に！',
  },
];

export default quickGuideData;
